"use client";

import { getLink } from "@utils/linkUtils";
import { useLocale } from "next-intl";
import Link from "next/link";
import React, { useContext } from "react";

import Icon from "@/components/ui/Icon/Icon";
import { ModalsContext } from "@/context/ModalsContext";

import { EditorialModuleListIcon as EditorialModuleListIconType } from "./type";

export interface EditorialModuleListProps {
  entry: EditorialModuleListIconType;
}

function renderButtons(
  lines: EditorialModuleListIconType["lines"],
  locale: string,
  setEnquireModalOpen: (open: boolean) => void,
  enquireKeywords: string[],
) {
  let hasEnquireShown = false;

  return lines?.map((cta, index) => {
    const isEnquireNow = enquireKeywords.some((keyword) => cta.link?.url?.includes(keyword));

    if (isEnquireNow) {
      if (hasEnquireShown) return null;
      hasEnquireShown = true;
      return (
        <button type="button" key={index} className="flex items-center gap-m" onClick={() => setEnquireModalOpen(true)}>
          {cta.link.icon && <Icon size="24" name={cta.link.icon} className="stroke-black" />}
          <p className="font-medium font-secondary text-s">{cta.label}</p>
        </button>
      );
    }

    const href = getLink(cta, locale);
    if (href) {
      return (
        <Link href={href} className="flex items-center gap-m" key={index}>
          {cta.link.icon && <Icon size="24" name={cta.link.icon} className="stroke-black" />}
          <p className="font-medium font-secondary text-s">{cta.label}</p>
        </Link>
      );
    }

    return (
      <div className="flex items-center gap-m" key={index}>
        {cta.link.icon && <Icon size="24" name={cta.link.icon} className="stroke-black" />}
        <p className="font-medium font-secondary text-s">{cta.label}</p>
      </div>
    );
  });
}

export default function EditorialModuleList({ entry }: EditorialModuleListProps) {
  const locale = useLocale();
  const { setEnquireModalOpen } = useContext(ModalsContext);
  const enquireKeywords = ["#enquireNow", "#callUs", "#contactUs"];

  const renderedButtons = renderButtons(entry.lines || [], locale, setEnquireModalOpen, enquireKeywords);

  return (
    <div className="h-full flex flex-col items-center md:justify-center px-m pt-l pb-[40px] md:pt-[40px]">
      <div className="pl-m benefitsContainer">
        {entry.title && <h3 className="font-medium font-primary text-s pb-l pt-xs">{entry.title}</h3>}
        {entry.textList && (
          <ul className="list-disc pl-m pb-xs">
            {entry.textList.map((item, index) => (
              <li className="font-secondary font-secondary-light text-m" key={index}>
                {item}
              </li>
            ))}
          </ul>
        )}
        {entry.lines && <div className="flex flex-col gap-l py-xs">{renderedButtons}</div>}
      </div>
    </div>
  );
}
